import { render, staticRenderFns } from "./ElectiveCosmetList.vue?vue&type=template&id=60c2bc0c&scoped=true&"
import script from "./ElectiveCosmetList.vue?vue&type=script&lang=js&"
export * from "./ElectiveCosmetList.vue?vue&type=script&lang=js&"
import style0 from "./ElectiveCosmetList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ElectiveCosmetList.vue?vue&type=style&index=1&id=60c2bc0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2bc0c",
  null
  
)

export default component.exports